import React, { createContext, ReactNode, useContext, useState } from 'react'

export namespace ModalSpace {
  export interface ModalData {
    type?: 'default' | 'custom'
    contents?: {
      t?: string //title
      d?: string //desc
      children?: ReactNode
    }
    button?: {
      direction?: 'column' | 'row'
      cancel?: { t: string; f?: () => void } // t: text
      submit?: { t: string; f?: () => void } //f: func
    }
  }

  export interface ModalContextValue {
    isOpen: boolean
    modalData: ModalSpace.ModalData
    closeModal: () => Promise<void>
    openModal: (modalData: ModalSpace.ModalData) => unknown
  }
}

const modalInitialValue: ModalSpace.ModalData = {
  type: 'default',
  contents: {
    t: '',
    d: '',
    children: <></>,
  },
  button: {
    direction: 'row',
    cancel: { t: '취소', f: () => {} },
    submit: { t: '확인', f: () => {} },
  },
}

const contextInitialValue = {
  isOpen: false,
  openModal: () => {},
  closeModal: async () => {},
  modalData: modalInitialValue,
}

const ModalContext = createContext<ModalSpace.ModalContextValue>(contextInitialValue)

export const ModalContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [modalData, setModalData] = useState<ModalSpace.ModalData>(modalInitialValue)

  const openModal = (ModalData: ModalSpace.ModalData) => {
    setIsOpen(true)
    setModalData({ ...ModalData })
  }

  const closeModal = async () => {
    setIsOpen(false)
    setModalData(modalInitialValue)
  }

  return (
    <ModalContext.Provider value={{ isOpen, openModal, closeModal, modalData }}>
      {children}
    </ModalContext.Provider>
  )
}

export function useModal() {
  return useContext(ModalContext)
}
